let searchInsightsAllowed = false;

export const setSearchInsightsAllowed = (allowed: boolean) => {
  searchInsightsAllowed = allowed;
};

export const canUseSearchInsights = () => searchInsightsAllowed;
